const state = {
    cardValue: 0,
    cardUrl: "card1.png",
    cardContent: "" || "No content set yet",
    recipientName: "",
    recipientEmail: "",
    selectedCardValue: 0,
    curValueListIndex: 0,
    curCardValueIndex: 0,
    buyCardForm: {
        cardValue: "" ,
        savedCards: ["**** **** **** 1111"] ,
        customValue: "",
        cardContentList: [
          "Congratulations",
          "Thank you",
          "Happy Birthday",
          "Love you",
        ],
        buyFor: "",
        name: "",
        email: "",
        message: "",
        deliveryTime: "",
        delivery: "",
        cardNumber: "" ,
        cardDate: "",
        cardCVC: "" ,
        timeZone: "",
        sendDate: "",
        selected: "",
        isFirstVisit: true,
        orderComplete: false,
      },
};

export const mutations = {
  setcurValueListIndex(state, curValueListIndex) {
    state.curValueListIndex = curValueListIndex;
  },
  setcardValue(state, cardValue) {
    state.selectedCardValue = cardValue;
  },
  setbuyFromcardValue(state, cardValue) {
    state.buyCardForm.cardValue = cardValue;
  },
  setCardContent(state, cardContent){
    state.cardContent = cardContent;
  },
  setFormBuyFor(state, formbuyfor){
    state.buyCardForm.buyFor = formbuyfor;
  },
  setFormBuyDelivery(state, formbuydelivery){
    state.buyCardForm.delivery = formbuydelivery;
  },
  setCardUrl(state, cardurl){
    state.cardUrl = cardurl;
  }
};

export const actions = {

};

export const getters = {
  buyCardForm: state => {
    return state.buyCardForm;
  },
  selectedCardValue: state => {
    return state.selectedCardValue;
  },
  curValueListIndex: state => {
    return state.curValueListIndex;
  },
  allGiftState: state => {
    return state;
  }

  
};

export default {
  state,
  mutations,
  actions,
  getters
};
